<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Manage Product
      </h6>

      <div class="container-fluid">
        <div style="border: 0; padding: 0; min-height: 0" class="navbar background_color">
          <div class="d-flex">
            <b-input-group size="sm" style="width: 225px;">
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search"
                class="bdr-rad"
              />
            </b-input-group>
            <div style="margin-top: 11px" class="ms-2">
              <span class="custom-breadcrumb">
                Showing {{ currentPage }}-{{ currentPage * perPage }} of {{ totalRows }} items.
              </span>
            </div>
          </div>

          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button @click="goCreate" class="btn btn-sm btn-outline-primary mb-1 mt-0 bdr-rad">
              Create Product
            </button>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else class="table-responsive">
              <b-table
                responsive
                class="table-hover"
                style="font-size: small"
                :items="products"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                head-variant="dark"
                :filter="filter"
                :filter-included-fields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                show-empty
                small
                @filtered="onFiltered"
              >
                <template #cell(Photo)="row">
                  <img
                    v-if="row.item.Photo"
                    :src="photoUrl(row.item.Photo)"
                    alt="Photo"
                    class="product-photo"
                  />
                  <span v-else>-</span>
                </template>

                <template #cell(Price)="row">
                  {{ formatPrice(row.item.Price) }}
                </template>

                <template #cell(actions)="row">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu bdr-rad">
                      <a class="dropdown-item mouse-cursor" @click="viewItem(row.item.id)">View</a>
                    </div>
                  </div>
                </template>
              </b-table>

              <b-col style="padding-left: 0" sm="7" md="2" class="my-1 mb-4">
                <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm" />
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: {
    TopNavbar,
    ContentFooter,
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      products: [],
      filter: null,
      filterOn: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      isLoading: true,
      fields: [
        { key: 'SKU', label: 'SKU', sortable: true },
        { key: 'Photo', label: 'Photo', sortable: false },
        { key: 'Name', label: 'Name', sortable: true },
        { key: 'Price', label: 'Price', sortable: true },
        { key: 'Winery', label: 'Winery', sortable: true },
        { key: 'Country', label: 'Country', sortable: true },
        { key: 'Region', label: 'Region', sortable: true },
        { key: 'Varietal', label: 'Varietal', sortable: true },
        { key: 'Type', label: 'Type', sortable: true },
        { key: 'Body', label: 'Body', sortable: true },
        { key: 'actions', label: 'Actions', class: 'width-custom8' },
      ],
    };
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    goCreate() {
      this.$router.push('/dproduct/create');
    },
    viewItem(id) {
      this.$router.push('/dproduct/view?id=' + id);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatPrice(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }

      const amount = Number(value);
      return Number.isNaN(amount) ? '$' + value : '$' + amount.toFixed(2);
    },
    photoUrl(path) {
      if (!path) {
        return '';
      }

      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
      }

      return path.startsWith('/') ? path : '/' + path;
    },
    async loadProducts() {
      try {
        const { data } = await axios.get('/dproduct/index', {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-Type': 'application/json',
          },
        });
        this.products = data.all_data || [];
        this.totalRows = this.products.length;
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.bdr-rad {
  border-radius: 12px;
}

.bdr-rad2 {
  border-radius: 15px;
}

.decoration {
  text-decoration: none;
  color: white !important;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}

.mouse-cursor {
  cursor: pointer;
}

.product-photo {
  width: 54px;
  height: 54px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #d6d6d6;
}
</style>
